'use client'

import { usePathname } from 'next/navigation'
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Toaster } from "@/components/ui/sonner";

export default function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isLoginPage = pathname === '/login';

  // Nếu là trang đăng nhập, chỉ render nội dung gốc không gò bó giao diện
  if (isLoginPage) {
    return (
      <div className="min-h-screen text-slate-900 bg-white">
        {children}
        <Toaster />
      </div>
    );
  }

  // Giao diện có Sidebar và Header dành cho các trang có quyền admin
  return (
    <div className="flex h-[100dvh] w-full overflow-hidden text-slate-900 bg-slate-50/40 relative">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-3 sm:p-6 md:p-8 pb-[100px] md:pb-8">
          {children}
        </main>
      </div>
      <Toaster />
    </div>
  )
}
